import React, {Component} from "react"

import withAuth, {WithAuth} from "@irati/auth/helpers/auth/withAuth"
import Button from "@irati/ui/src/Button"
import Form from "@irati/ui/src/Form"
import FormattedMessage, {InjectIntl, injectIntl} from "@irati/utils/lang"
import {Body, Label} from "@irati/ui/src/Typography"
import {createCompanyNewsRow} from "@irati/homepage/services/homepage"
import tracking from "@irati-tracking/homepage"

import getNewDefaultTiles from "../utils/getNewDefaultTiles"
import calculateHeightFromContent from "../utils/calculateHeightFromContent"
import {CancelButton, StyledCol, StyledRow, StyledSelecter, StyledSelectItem, StyledVerticalDiv} from "./styled"
import {ModalContent, StyledFooter} from "../../Modal/styled"
import {Modal} from "../../Modal"
import {RowNames} from "../../types"

interface Props extends InjectIntl, WithAuth {
  onClose: () => void,
  rowInt: number
}

interface State {
  load?: boolean,
  selected: RowNames
}

class CompanyNewsModal extends Component<Props, State> {
  state: State = {selected: RowNames.THREE_EQUAL}

  updateSelectedRow = (selected: RowNames) => {
    this.setState({selected})
    tracking.homePageSelectRowSize(selected)
  }

  onSubmit = () => {
    const {selected} = this.state
    const {onClose, rowInt, auth} = this.props

    const newTiles = getNewDefaultTiles(selected, rowInt)

    const variables = {
      tenantId: auth.business.uuid,
      tiles: newTiles
    }

    this.setState({load: true})
    return createCompanyNewsRow(variables).then(() => {
      onClose()
      this.setState({load: false})
    })
  }

  render() {
    const {load, selected} = this.state
    const {formatMessage, onClose} = this.props

    const options = [
      {label: formatMessage({id: "platform.homepage.companyNews.newRow.option"}, {value: "2"}), value: RowNames.TWO_EQUAL},
      {label: formatMessage({id: "platform.homepage.companyNews.newRow.option"}, {value: "3"}), value: RowNames.THREE_EQUAL},
      {label: formatMessage({id: "platform.homepage.companyNews.newRow.option"}, {value: "4"}), value: RowNames.FOUR_EQUAL}
    ]

    return (
      <Modal onClose={onClose} header={<FormattedMessage id="platform.homepage.companyNews.newRow.title" />}>
        <Form>
          <ModalContent>
            <Body>
              <FormattedMessage id="platform.homepage.companyNews.newRow.description" />
            </Body>

            <StyledSelecter>
              {options.map((option) => {
                const tiles = getNewDefaultTiles(option.value, 0)
                return (
                  <StyledSelectItem
                    key={option.value}
                    selected={option.value === selected}
                    onClick={() => {
                      if (!load) {
                        this.updateSelectedRow(option.value)
                      }
                    }}>
                    <StyledRow>
                      <StyledVerticalDiv>
                        {tiles.map((tile) => (
                          <StyledCol
                            key={`${option.value}-${tile.ypos}`}
                            height={Math.round(calculateHeightFromContent(tiles) / 10)}
                            xs={tile.config.columnWidth} />
                        ))}
                      </StyledVerticalDiv>
                    </StyledRow>
                    <Label display="block">{option.label}</Label>
                  </StyledSelectItem>
                )
              })}
            </StyledSelecter>
          </ModalContent>

          <StyledFooter>
            <CancelButton tertiary disabled={load} onClick={onClose}>
              <FormattedMessage id="platform.homepage.companyNews.newRow.cancel" />
            </CancelButton>
            <Button disabled={load} onClick={this.onSubmit} primary marginLeft={2}>
              <FormattedMessage id="platform.homepage.companyNews.newRow.save" />
            </Button>
          </StyledFooter>
        </Form>
      </Modal>
    )
  }
}

export default injectIntl(withAuth(CompanyNewsModal))
